import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { playerComparisonFiltersSelector } from '../../../../../../../../store/js/modules/statspro/player-comparison/selectors/filters-selector';
import { UPDATE_FILTER_ITEM } from '../../../../../../../../store/js/modules/statspro/player-comparison/actions';
import { useTeamsForSeason } from '../../../../../../../../../../common/react/hooks/use-teams-for-season';
import { getTranslation } from '../../../../../../../../../../common/react/utils/translations';
import { SelectMultiple } from '../../../../../../../../../../common/react/components/select-multiple';
import { SvgIcon } from '../../../../../../../../../../common/react/components/SvgIcon';

export const PlayerSelectionTeamsFilters = ({
    addOnResetCallback,
    compseason
}) => {
    const dispatch = useDispatch();

    const filters = useSelector(playerComparisonFiltersSelector);
    const teams = useTeamsForSeason(compseason);

    const updateFilterItem = (filterItem, value) => {
        dispatch(UPDATE_FILTER_ITEM.request({ filterItem, value }));
    };

    return (
        <SelectMultiple
            items={teams}
            getInitialSelectedItems={() => {
                return teams.filter((t) =>
                    filters.teams.includes(t.providerId)
                );
            }}
            label={getTranslation('label.statsLeaders.filters.team')}
            itemToString={(team) => team.name}
            onSelectedItemsChange={(team) => {
                updateFilterItem(
                    'teams',
                    team.map((t) => t.providerId)
                );
            }}
            addOnResetCallback={addOnResetCallback}
            getItemText={(item) => item.name}
            getItemLabel={(item) => (
                <span
                    style={{
                        alignItems: 'center',
                        display: 'flex',
                        justifyContent: 'space-between',
                        lineHeight: 1,
                        width: '100%'
                    }}
                >
                    <span style={{ marginRight: '1rem' }}>{item.name}</span>
                    <SvgIcon
                        icon={`aflc-${item.abbreviation.toLowerCase()}-flag`}
                        style={{ width: '3.1rem', maxHeight: '3rem' }}
                    />
                </span>
            )}
        />
    );
};

PlayerSelectionTeamsFilters.propTypes = {
    addOnResetCallback: PropTypes.func,
    compseason: PropTypes.string.isRequired
};
